import React, { useEffect, useState } from 'react';
import { fetchStatusHistory } from '../services/serviceRecordsService';
import './AppointmentFullDetailView.css';

const AppointmentFullDetailView = ({ appointment, serviceRecord, assignmentHistory }) => {
  const [statusHistory, setStatusHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStatusHistory = async () => {
      if (!appointment) {
        return;
      }
      
      const randevuId = appointment._id || appointment.id;
      
      if (!randevuId || typeof randevuId !== 'string') {
        return;
      }
      
      setLoading(true);
      try {
        const response = await fetchStatusHistory(randevuId);
        setStatusHistory(response?.veri?.durumGecmisi || []);
      } catch (error) {
        setStatusHistory([]);
      } finally {
        setLoading(false);
      }
    };

    loadStatusHistory();
  }, [appointment]);


  const formatDate = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '—';
    return new Intl.DateTimeFormat('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  };

  const formatShortDate = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '—';
    return new Intl.DateTimeFormat('tr-TR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  };

  const calculateWarrantyEndDate = (startDate, months) => {
    if (!startDate || !months) return null;
    const date = new Date(startDate);
    date.setMonth(date.getMonth() + parseInt(months));
    return date;
  };

  if (!appointment && !serviceRecord) {
    return (
      <div className="appointment-full-detail">
        <p style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
          Randevu bilgileri yükleniyor...
        </p>
      </div>
    );
  }

  return (
    <div className="appointment-full-detail">
      <div className="detail-header">
        <h2>RANDEVU DETAY RAPORU</h2>
        <p className="detail-subtitle">Randevu No: {appointment?.randevuNumarasi || '—'}</p>
      </div>

      {/* Genel Bilgiler İçeriği */}
      <div>

      {/* Randevu Bilgileri */}
      <div className="detail-section">
        <h3 className="section-title">RANDEVU BİLGİLERİ</h3>
        <div className="detail-grid">
          <div className="detail-row">
            <span className="detail-label">Randevu Tarihi:</span>
            <span className="detail-value">
              {appointment?.randevuTarihi ? formatDate(appointment.randevuTarihi) : '—'}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Randevu Saati:</span>
            <span className="detail-value">{appointment?.randevuSaati || '—'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Durum:</span>
            <span className="detail-value">{appointment?.durum || '—'}</span>
          </div>
          {/* İptal bilgileri (Randevu İptal Edildi ise) */}
          {(appointment?.durum === 'Randevu İptal Edildi' || appointment?.iptalNedeni || appointment?.iptalEden || appointment?.iptalEdenIsim) && (
            <>
              <div className="detail-row">
                <span className="detail-label">İptal Nedeni:</span>
                <span className="detail-value">{appointment?.iptalNedeni || '—'}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">İptal Eden:</span>
                <span className="detail-value">{appointment?.iptalEdenIsim || appointment?.iptalEden || '—'}</span>
              </div>
              {appointment?.iptalTarihi && (
                <div className="detail-row">
                  <span className="detail-label">İptal Tarihi:</span>
                  <span className="detail-value">{new Date(appointment.iptalTarihi).toLocaleString('tr-TR')}</span>
                </div>
              )}
            </>
          )}
          <div className="detail-row">
            <span className="detail-label">Teknik Servis:</span>
            <span className="detail-value">
              {appointment?.teknikServisId?.ad || appointment?.teknikServis?.ad || appointment?.teknikServis?.teknikServisAdi || '—'}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Teknisyen:</span>
            <span className="detail-value">
              {appointment?.teknisyen 
                ? `${appointment.teknisyen.adi || ''} ${appointment.teknisyen.soyadi || ''}`.trim() || '—'
                : '—'}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Açıklama:</span>
            <span className="detail-value">{appointment?.aciklama || '—'}</span>
          </div>
        </div>
      </div>

      {/* Müşteri Bilgileri */}
      <div className="detail-section">
        <h3 className="section-title">MÜŞTERİ BİLGİLERİ</h3>
        <div className="detail-grid">
          <div className="detail-row">
            <span className="detail-label">Müşteri Adı:</span>
            <span className="detail-value">
              {(() => {
                // Önce musteri objesini kontrol et (formatlanmış veri)
                if (serviceRecord?.musteri && typeof serviceRecord.musteri === 'object' && !Array.isArray(serviceRecord.musteri)) {
                  const name = `${serviceRecord.musteri.adi || ''} ${serviceRecord.musteri.soyadi || ''}`.trim();
                  if (name) return name;
                }
                // Sonra musteriId objesini kontrol et (populate edilmiş)
                if (serviceRecord?.musteriId && typeof serviceRecord.musteriId === 'object' && !Array.isArray(serviceRecord.musteriId)) {
                  const name = `${serviceRecord.musteriId.name || ''} ${serviceRecord.musteriId.surname || ''}`.trim();
                  if (name) return name;
                }
                return '—';
              })()}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Telefon:</span>
            <span className="detail-value">
              {(() => {
                // Önce musteri objesini kontrol et
                if (serviceRecord?.musteri && typeof serviceRecord.musteri === 'object' && !Array.isArray(serviceRecord.musteri)) {
                  if (serviceRecord.musteri.telefon) return serviceRecord.musteri.telefon;
                }
                // Sonra musteriId objesini kontrol et
                if (serviceRecord?.musteriId && typeof serviceRecord.musteriId === 'object' && !Array.isArray(serviceRecord.musteriId)) {
                  if (serviceRecord.musteriId.phone) return serviceRecord.musteriId.phone;
                }
                return '—';
              })()}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">E-posta:</span>
            <span className="detail-value">
              {(() => {
                // Önce musteri objesini kontrol et
                if (serviceRecord?.musteri && typeof serviceRecord.musteri === 'object' && !Array.isArray(serviceRecord.musteri)) {
                  if (serviceRecord.musteri.mail) return serviceRecord.musteri.mail;
                }
                // Sonra musteriId objesini kontrol et
                if (serviceRecord?.musteriId && typeof serviceRecord.musteriId === 'object' && !Array.isArray(serviceRecord.musteriId)) {
                  if (serviceRecord.musteriId.mail) return serviceRecord.musteriId.mail;
                }
                return '—';
              })()}
            </span>
          </div>
        </div>
      </div>

      {/* MH / Teknisyen cihaz özeti */}
      {(() => {
        const mh = appointment?.mhCihazOzeti;
        const tech = appointment?.teknisyenCihazOnay;
        const mhUrun = mh?.urunAdi || serviceRecord?.kurulumUrunAdi || '';
        const mhSeri = mh?.seriNumarasi || serviceRecord?.kurulumSeriNo || '';
        const techUrun = tech?.urunAdi || '';
        const techSeri = tech?.seriNumarasi || '';
        if (!mhUrun && !techUrun && !mhSeri && !techSeri) return null;
        return (
          <div className="detail-section">
            <h3 className="section-title">CİHAZ (MH / TEKNİSYEN)</h3>
            <div className="detail-grid">
              <div className="detail-row">
                <span className="detail-label">Müşteri hizmetleri:</span>
                <span className="detail-value">
                  {mhUrun || '—'}{mhSeri ? ` · Seri: ${mhSeri}` : ''}
                </span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Teknisyen onayı:</span>
                <span className="detail-value">
                  {techUrun || '—'}{techSeri ? ` · Seri: ${techSeri}` : ''}
                </span>
              </div>
              {tech?.mhIleUyusuyor === false && (
                <div className="detail-row">
                  <span className="detail-label">Durum:</span>
                  <span className="detail-value" style={{ color: '#b45309', fontWeight: 600 }}>
                    Seçimler farklı
                  </span>
                </div>
              )}
            </div>
          </div>
        );
      })()}

      {/* Cihaz Bilgileri */}
      {(() => {
        // Önce cihazlar array'ini kontrol et (formatlanmış veri)
        const cihazlarArray = serviceRecord?.cihazlar && Array.isArray(serviceRecord.cihazlar) && serviceRecord.cihazlar.length > 0
          ? serviceRecord.cihazlar
          : null;
        // Sonra cihazIds array'ini kontrol et (ama sadece obje array'i ise)
        const cihazIdsArray = !cihazlarArray && serviceRecord?.cihazIds && Array.isArray(serviceRecord.cihazIds) && serviceRecord.cihazIds.length > 0
          ? serviceRecord.cihazIds.filter(cihaz => typeof cihaz === 'object' && !Array.isArray(cihaz))
          : null;
        
        const cihazlarToRender = cihazlarArray || cihazIdsArray || [];
        
        if (cihazlarToRender.length === 0) return null;
        
        return (
          <div className="detail-section">
            <h3 className="section-title">CİHAZ BİLGİLERİ</h3>
            {cihazlarToRender.map((cihaz, index) => (
            <div key={index} className="detail-grid" style={{ marginBottom: '20px', paddingBottom: '15px', borderBottom: index < (serviceRecord.cihazIds || serviceRecord.cihazlar || []).length - 1 ? '1px dashed #ccc' : 'none' }}>
              <div className="detail-row">
                <span className="detail-label">Cihaz Adı:</span>
                <span className="detail-value">
                  {cihaz.icerikId?.icerikAdi || cihaz.icerik?.icerikAdi || cihaz.urun?.urunAdi || 'Belirtilmemiş'}
                </span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Seri Numarası:</span>
                <span className="detail-value">{cihaz.seriNumarasi || '—'}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Kurulum Tarihi:</span>
                <span className="detail-value">
                  {cihaz.kurulumTarihi 
                    ? formatShortDate(cihaz.kurulumTarihi)
                    : cihaz.garantiBaslangicTarihi 
                      ? formatShortDate(cihaz.garantiBaslangicTarihi) 
                      : '—'}
                </span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Garanti Süresi:</span>
                <span className="detail-value">{cihaz.garantiSuresi ? `${cihaz.garantiSuresi} Ay` : '—'}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Garanti Bitiş Tarihi:</span>
                <span className="detail-value">
                  {cihaz.garantiBitisTarihi 
                    ? formatShortDate(cihaz.garantiBitisTarihi)
                    : cihaz.garantiBaslangicTarihi && cihaz.garantiSuresi
                      ? formatShortDate(calculateWarrantyEndDate(cihaz.garantiBaslangicTarihi, cihaz.garantiSuresi))
                      : '—'}
                </span>
              </div>
            </div>
            ))}
          </div>
        );
      })()}

      {/* Servis Kaydı Bilgileri */}
      <div className="detail-section">
        <h3 className="section-title">SERVİS KAYDI BİLGİLERİ</h3>
        <div className="detail-grid">
          <div className="detail-row">
            <span className="detail-label">İşlem Tipi:</span>
            <span className="detail-value">{serviceRecord?.islemTipi || '—'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Önem Derecesi:</span>
            <span className="detail-value">{serviceRecord?.onemDerecesi || '—'}</span>
          </div>
          {serviceRecord?.islemTipi === 'Arıza' && (
            <div className="detail-row">
              <span className="detail-label">Arıza Notu:</span>
              <span className="detail-value">{serviceRecord?.arizaNotu || '—'}</span>
            </div>
          )}
          <div className="detail-row">
            <span className="detail-label">Durum:</span>
            <span className="detail-value">{serviceRecord?.durum || '—'}</span>
          </div>
        </div>
      </div>

      {/* Servis Kaydı Oluşturma Bilgileri */}
      <div className="detail-section">
        <h3 className="section-title">SERVİS KAYDI OLUŞTURMA BİLGİLERİ</h3>
        <div className="detail-grid">
          <div className="detail-row">
            <span className="detail-label">Oluşturulma Tarihi:</span>
            <span className="detail-value">
              {serviceRecord?.olusturmaTarihi || serviceRecord?.createdAt ? formatDate(serviceRecord.olusturmaTarihi || serviceRecord.createdAt) : '—'}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Oluşturan Kullanıcı:</span>
            <span className="detail-value">
              {serviceRecord?.olusturanKullanici?.kullaniciAdi || 
               (serviceRecord?.olusturanKullanici?.ad && serviceRecord?.olusturanKullanici?.soyad 
                 ? `${serviceRecord.olusturanKullanici.ad} ${serviceRecord.olusturanKullanici.soyad}`.trim() 
                 : '—')}
            </span>
          </div>
        </div>
      </div>

      {/* Randevu Oluşturma Bilgileri */}
      <div className="detail-section">
        <h3 className="section-title">RANDEVU OLUŞTURMA BİLGİLERİ</h3>
        <div className="detail-grid">
          <div className="detail-row">
            <span className="detail-label">İlk Oluşturulma Tarihi:</span>
            <span className="detail-value">
              {appointment?.olusturmaTarihi || appointment?.createdAt ? formatDate(appointment.olusturmaTarihi || appointment.createdAt) : '—'}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Oluşturan Kullanıcı:</span>
            <span className="detail-value">
              {(() => {
                // Önce randevunun kendi olusturanKullanici objesini kontrol et (yeni format)
                if (appointment?.olusturanKullanici) {
                  const olusturan = appointment.olusturanKullanici;
                  if (typeof olusturan === 'object') {
                    return olusturan.kullaniciAdi || 
                           (olusturan.ad && olusturan.soyad ? `${olusturan.ad} ${olusturan.soyad}`.trim() : olusturan.ad) ||
                           '—';
                  }
                }
                // Sonra randevunun kendi olusturanKullaniciId'sini kontrol et (populate edilmiş)
                if (appointment?.olusturanKullaniciId) {
                  const olusturan = appointment.olusturanKullaniciId;
                  if (typeof olusturan === 'object') {
                    // Populate edilmiş kullanıcı objesi
                    return olusturan.kullaniciAdi || 
                           (olusturan.ad && olusturan.soyad ? `${olusturan.ad} ${olusturan.soyad}`.trim() : olusturan.ad) ||
                           '—';
                  }
                }
                // Sonra servis kaydının olusturanKullanici'sini kontrol et (yeni format)
                if (serviceRecord?.olusturanKullanici) {
                  const olusturan = serviceRecord.olusturanKullanici;
                  if (typeof olusturan === 'object') {
                    return olusturan.kullaniciAdi || 
                           (olusturan.ad && olusturan.soyad ? `${olusturan.ad} ${olusturan.soyad}`.trim() : olusturan.ad) ||
                           '—';
                  }
                }
                // Sonra servis kaydının olusturanKullaniciId'sini kontrol et (eski format)
                if (serviceRecord?.olusturanKullaniciId) {
                  const olusturan = serviceRecord.olusturanKullaniciId;
                  if (typeof olusturan === 'object') {
                    return olusturan.kullaniciAdi || 
                           (olusturan.ad && olusturan.soyad ? `${olusturan.ad} ${olusturan.soyad}`.trim() : olusturan.ad) ||
                           '—';
                  }
                }
                // Son olarak appointment.createdBy'ı kontrol et
                if (appointment?.createdBy?.kullaniciAdi) {
                  return appointment.createdBy.kullaniciAdi;
                }
                return '—';
              })()}
            </span>
          </div>
        </div>
      </div>

      {/* Atama Geçmişi (Atama + Durum Değişiklikleri Birleşik) */}
      {(() => {
        // Atama geçmişi ve durum geçmişini birleştir
        const allChanges = [];
        
        // Atama geçmişinden ekle
        if (assignmentHistory && assignmentHistory.length > 0) {
          assignmentHistory.forEach(item => {
            const tarih = item.tarih || item.atamaTarihi || item.iptalTarihi || item.degistirmeTarihi;
            allChanges.push({
              type: 'assignment',
              date: tarih,
              data: item
            });
          });
        }
        
        // Durum geçmişinden ekle
        if (!loading && statusHistory && statusHistory.length > 0) {
          statusHistory.forEach(item => {
            allChanges.push({
              type: 'status',
              date: item.degistirmeTarihi,
              data: item
            });
          });
        }
        
        // Tarihe göre sırala (en yeni en üstte)
        allChanges.sort((a, b) => {
          const dateA = a.date ? new Date(a.date) : new Date(0);
          const dateB = b.date ? new Date(b.date) : new Date(0);
          return dateB - dateA;
        });
        
        if (allChanges.length === 0) {
          return null;
        }
        
        return (
          <div className="detail-section">
            <h3 className="section-title">ATAMA GEÇMİŞİ</h3>
            <table className="detail-table">
              <thead>
                <tr>
                  <th style={{ width: '140px' }}>Tarih</th>
                  <th style={{ width: '130px' }}>Değişiklik Tipi</th>
                  <th>Açıklama</th>
                  <th style={{ width: '120px' }}>Durum</th>
                  <th>İşlem Yapan</th>
                  <th>Gerekçe/Not</th>
                </tr>
              </thead>
              <tbody>
                {allChanges.map((change, index) => {
                  if (change.type === 'assignment') {
                    const item = change.data;
                    return (
                      <tr key={`assignment-${index}`}>
                        <td>{change.date ? formatShortDate(change.date) : '—'}</td>
                        <td>
                          <span className={`badge ${
                            item.atamaTipi === 'Teknisyen İptali' || item.atamaTipi === 'Teknik Servis İptali' 
                              ? 'danger' 
                              : 'primary'
                          }`}>
                            {item.atamaTipi || 'Atama'}
                          </span>
                        </td>
                        <td>
                          {item.atamaTipi === 'Teknisyen İptali' || item.atamaTipi === 'Teknik Servis İptali'
                            ? 'Atama iptal edildi'
                            : `${item.atananAdi || '—'} atandı`}
                        </td>
                        <td>
                          <span className={`status-badge ${item.durum === 'Atandı' ? 'success' : 'error'}`}>
                            {item.durum || '—'}
                          </span>
                        </td>
                        <td>
                          {item.yapanKisi 
                            ? `${item.yapanKisi.ad || ''} ${item.yapanKisi.soyad || ''}`.trim() || item.yapanKisi.kullaniciAdi
                            : item.atamaYapan || '—'}
                        </td>
                        <td>{item.gerekce || '—'}</td>
                      </tr>
                    );
                  } else {
                    // status change
                    const item = change.data;
                    return (
                      <tr key={`status-${index}`}>
                        <td>{change.date ? formatShortDate(change.date) : '—'}</td>
                        <td>
                          <span className="badge info">Durum Değişikliği</span>
                        </td>
                        <td>
                          <strong>{item.eskiDurum || '—'}</strong> → <strong>{item.yeniDurum || '—'}</strong>
                        </td>
                        <td>
                          <span className="status-badge info">{item.yeniDurum || '—'}</span>
                        </td>
                        <td>
                          {item.degistirenAdi || '—'}
                          {item.degistirenRol && ` (${item.degistirenRol})`}
                        </td>
                        <td>{item.gerekce || '—'}</td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </table>
          </div>
        );
      })()}

      {/* Durum Değişiklikleri Logları (Ayrı Detaylı Görünüm) */}
      {!loading && statusHistory && statusHistory.length > 0 && (
        <div className="detail-section">
          <h3 className="section-title">DURUM DEĞİŞİKLİKLERİ LOGLARI</h3>
          <table className="detail-table">
            <thead>
              <tr>
                <th style={{ width: '140px' }}>Değişim Tarihi</th>
                <th>Önceki Durum</th>
                <th>Yeni Durum</th>
                <th>Değiştiren Kişi</th>
                <th style={{ width: '100px' }}>Rol</th>
                <th>Gerekçe</th>
              </tr>
            </thead>
            <tbody>
              {statusHistory.map((item, index) => (
                <tr key={index}>
                  <td>{item.degistirmeTarihi ? formatShortDate(item.degistirmeTarihi) : '—'}</td>
                  <td>{item.eskiDurum || '—'}</td>
                  <td>
                    <span className="status-badge info">{item.yeniDurum || '—'}</span>
                  </td>
                  <td>{item.degistirenAdi || '—'}</td>
                  <td>{item.degistirenRol || '—'}</td>
                  <td>{item.gerekce || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {loading && (
        <div className="detail-section">
          <p style={{ textAlign: 'center', color: '#666' }}>Durum geçmişi yükleniyor...</p>
        </div>
      )}
      </div>


      <div className="detail-footer">
        <p>Bu rapor {formatDate(new Date())} tarihinde oluşturulmuştur.</p>
      </div>
    </div>
  );
};

export default AppointmentFullDetailView;
